import React from 'react';
import { createDropdownOption } from 'utils/helpers';
import noop from 'utils/noop';
import { StyledCoreUserMappingsDropdown, ReadOnlyLabel } from './CriteriaPropertyField.styled';

// type Props = {
//   /** If the dropdown has an error. */
//   error: boolean,
//   /** Array comtaining the group index, query index and criteria property index. */
//   fieldIdentifier: [],
//   /** Callback function when field value is changed. */
//   onChange: () => {},
//   /** The options of the dropdown. */
//   options: [],
//   /** Placeholder text. */
//   placeholder: string,
//   /** The value of the field. */
//   value: string,
//   disabled?: boolean,
// };

export default class CriteriaPropertyOptionsDropdown extends React.Component {
  static defaultProps = {
    error: false,
    fieldIdentifier: [],
    onChange: noop,
    options: [],
    disabled: false,
  };

  /**
   * handleChange
   * Callback function when value changes.
   * @param { Object } e: The change event.
   * @param { Object } updatedProps: Updated props containing updated value.
   * @returns { void }
   */
  handleChange = (e, { value }) => {
    const { fieldIdentifier, onChange } = this.props;
    onChange(value, ...fieldIdentifier);
  };

  formatOptions = () => {
    const { options } = this.props;
    return options.map((option, key) => createDropdownOption(option, option, `${key}-option`));
  };

  render() {
    const { error, placeholder, value, disabled } = this.props;
    const options = this.formatOptions();
    return (
      <>
        <ReadOnlyLabel>{value}</ReadOnlyLabel>
        <StyledCoreUserMappingsDropdown
          data-test="criteria-options-dropdown"
          isError={error}
          fluid
          onChange={this.handleChange}
          options={options}
          placeholder={placeholder}
          search
          value={value}
          disabled={disabled}
        />
      </>
    );
  }
}
